<ng-container *transloco="let t; read: 'widget-group-side-pane-item-component'">
  @if (widgetGroup) {
    <div class="widget-group-info">
      <mat-expansion-panel
        [expanded]="isExpanded"
        (closed)="itemAction.emit({ action: 'expand', data: false })"
        (opened)="itemAction.emit({ action: 'expand', data: true })"
        [hideToggle]="widgetGroup.isImpact"
        [disabled]="!!isDisabled && !isDashboardLocked"
        [ngStyle]="{
          'border-left':
            '6px solid rgba(' +
            widgetGroupColor.red +
            ' , ' +
            widgetGroupColor.green +
            ' , ' +
            widgetGroupColor.blue +
            ', ' +
            widgetGroupColor.alpha +
            ')',
        }"
      >
        <mat-expansion-panel-header
          [collapsedHeight]="'64px'"
          [expandedHeight]="'64px'"
          [class.disabled-pointer]="widgetGroup.isImpact"
          [matTooltip]="actionTooltip"
        >
          <mat-panel-title>
            <div class="widget-group__title-container">
              <xi-icon [icon]="isDashboardLevel ? 'community' : 'link'"></xi-icon>
              <span class="widget-group-title">
                <div *appMiddleEllipsize="widgetGroup.title"></div>
              </span>
              <div
                class="widget-group__title-edit-button-container"
                [class.widget-group__title-edit-button-container--disabled]="
                  isDisabled || !isEditable
                "
              >
                <xi-icon-button
                  icon="edit"
                  fill="no-fill"
                  (click)="onItemRenameClicked($event)"
                  [tooltip]="{ text: t('rename-group'), direction: 4 }"
                  [disabled]="!!isDisabled && !isEditable"
                >
                </xi-icon-button>
              </div>
            </div>
            <span class="widget-group__details-container">
              {{
                t('x-y-filters', {
                  x: getWidgetCount(widgetGroup),
                  y: widgetGroup.filterCount ? widgetGroup.filterCount : 0,
                })
              }}
            </span>
          </mat-panel-title>
          <div class="widget-group-actions">
            @if (isEditable && !widgetGroup.isImpact) {
              <span
                [matMenuTriggerFor]="widgetGroupMenuTrigger"
                (click)="$event.stopPropagation()"
                [class.disabled-pointer]="isDisabled"
              >
                <xi-icon-button
                  icon="kabob"
                  color="CXIC"
                  buttonSize="large"
                  [disabled]="!!isDisabled"
                >
                </xi-icon-button>
              </span>
            }
          </div>
        </mat-expansion-panel-header>
        @if (widgetGroup.filterCount === 0 && !widgetGroup.isImpact) {
          <div class="widget-group-no-filters">
            <p>{{ t('no-filters') }}</p>
            <div [matTooltip]="filterTooltip">
              <xi-default-button
                [stretch]="true"
                buttonSize="normal"
                text="{{ t('add-filter-button') }}"
                fill="text"
                color="CX"
                [disabled]="!hasDataSources || !!isDisabled"
                (onClick)="triggerItemAction('edit')"
              ></xi-default-button>
            </div>
          </div>
        }
        @if (widgetGroup.filterCount > 0 || widgetGroup.parameters) {
          <div class="widget-group-has-filters">
            <div class="widget-group-section-header">
              <p class="widget-group-section-header-text">
                {{ t('all-of-these', { group: getFilterCount(widgetGroup) }) }}
              </p>
              @if (widgetGroup.filterCount > 0 && !widgetGroup.isImpact) {
                <div class="widget-group-has-filters widget-group-edit-button">
                  <div [matTooltip]="filterTooltip">
                    <xi-default-button
                      [stretch]="true"
                      buttonSize="normal"
                      text="{{ t('edit-filter-button') }}"
                      fill="text"
                      color="CX"
                      (onClick)="triggerItemAction('edit')"
                      [disabled]="!hasDataSources || !!isDisabled"
                    ></xi-default-button>
                  </div>
                </div>
              }
            </div>
            @for (filter of widgetGroup.andFilters; track filter) {
              <div>
                <app-lex-xi-filter-pill
                  [filter]="filter"
                  [isActionDisabled]="!!isDisabled"
                  [actionTooltip]="actionTooltip"
                  [isParentFilter]="filter.parentFilter"
                  [dataSource]="widgetGroup.lastUsedDataSourceDisplayName"
                  [selectedFilters]="{
                    and: widgetGroup.andFilters,
                    or: widgetGroup.orFilters,
                    not: widgetGroup.notFilters,
                  }"
                  [sentimentScale]="sentimentScale"
                  filterOperator="and"
                  (filterAction)="onFilterAction($event, 'and', filter)"
                ></app-lex-xi-filter-pill>
              </div>
            }
            @if (widgetGroup.parameters?.scoreMetric) {
              <div>
                <div class="widget-group-button-parameter">
                  <span class="widget-group-short-label">{{ t('cf') }}</span>
                  <span
                    class="widget-group-content"
                    [class.ellipsis-loader]="!scoreMetricShortLabel"
                    [matTooltip]="scoreMetricLongLabel"
                  >
                    {{ scoreMetricShortLabel | truncate: 25 }}</span
                  >
                  <span class="widget-group-delete-button">
                    <xi-icon-button
                      fill="no-fill"
                      contrast="normal"
                      icon="split_filled"
                      [active]="false"
                      [tooltip]="{ text: t('parent-filter'), direction: 9 }"
                    ></xi-icon-button>
                  </span>
                </div>
              </div>
            }
            @if (widgetGroup.parameters?.previousStart) {
              <div>
                <div class="widget-group-button-parameter">
                  <span class="widget-group-short-label">{{ t('cf') }}</span>
                  <span
                    class="widget-group-content"
                    [matTooltip]="getPeriodLabel('previous', widgetGroup)"
                  >
                    {{ getPeriodLabel('previous', widgetGroup) | truncate: 25 }}
                  </span>
                  <span class="widget-group-delete-button">
                    <xi-icon-button
                      fill="no-fill"
                      contrast="normal"
                      icon="split_filled"
                      [active]="false"
                      [tooltip]="{ text: t('parent-filter'), direction: 9 }"
                    ></xi-icon-button>
                  </span>
                </div>
              </div>
            }
            @if (widgetGroup.parameters?.currentStart) {
              <div>
                <div class="widget-group-button-parameter">
                  <span class="widget-group-short-label">{{ t('cf') }}</span>
                  <span
                    class="widget-group-content"
                    [matTooltip]="getPeriodLabel('current', widgetGroup)"
                  >
                    {{ getPeriodLabel('current', widgetGroup) | truncate: 25 }}
                  </span>
                  <span class="widget-group-delete-button">
                    <xi-icon-button
                      fill="no-fill"
                      contrast="normal"
                      icon="split_filled"
                      [active]="false"
                      [tooltip]="{ text: t('parent-filter'), direction: 9 }"
                    ></xi-icon-button>
                  </span>
                </div>
              </div>
            }
            @if (!widgetGroup.isImpact) {
              <div class="widget-group-section-header">
                <p class="widget-group-section-header-text">
                  {{
                    t('any-of-these', {
                      filters: widgetGroup.orFilters ? widgetGroup.orFilters.length : 0,
                    })
                  }}
                </p>
              </div>
              @for (filter of widgetGroup.orFilters; track filter) {
                <div>
                  <app-lex-xi-filter-pill
                    [filter]="filter"
                    [isActionDisabled]="!!isDisabled"
                    [actionTooltip]="actionTooltip"
                    [isParentFilter]="filter.parentFilter"
                    [dataSource]="widgetGroup.lastUsedDataSourceDisplayName"
                    [selectedFilters]="{
                      and: widgetGroup.andFilters,
                      or: widgetGroup.orFilters,
                      not: widgetGroup.notFilters,
                    }"
                    [sentimentScale]="sentimentScale"
                    filterOperator="or"
                    (filterAction)="onFilterAction($event, 'or', filter)"
                  ></app-lex-xi-filter-pill>
                </div>
              }
            }
            @if (!widgetGroup.isImpact) {
              <div class="widget-group-section-header">
                <p class="widget-group-section-header-text">
                  {{
                    t('none-of-these', {
                      filters: widgetGroup.notFilters ? widgetGroup.notFilters.length : 0,
                    })
                  }}
                </p>
              </div>
              @for (filter of widgetGroup.notFilters; track filter) {
                <div>
                  <app-lex-xi-filter-pill
                    [filter]="filter"
                    [isActionDisabled]="!!isDisabled"
                    [actionTooltip]="actionTooltip"
                    [isParentFilter]="filter.parentFilter"
                    [dataSource]="widgetGroup.lastUsedDataSourceDisplayName"
                    [selectedFilters]="{
                      and: widgetGroup.andFilters,
                      or: widgetGroup.orFilters,
                      not: widgetGroup.notFilters,
                    }"
                    [sentimentScale]="sentimentScale"
                    filterOperator="not"
                    (filterAction)="onFilterAction($event, 'not', filter)"
                  ></app-lex-xi-filter-pill>
                </div>
              }
            }
          </div>
        }
      </mat-expansion-panel>
    </div>
  }

  <mat-menu #widgetGroupMenuTrigger class="menu-with-xi-icons">
    <ng-template matMenuContent>
      <div matTooltip="No datasources available" [matTooltipDisabled]="hasDataSources">
        <button
          mat-menu-item
          [disabled]="!hasDataSources || !widgetGroup.editable"
          (click)="triggerItemAction('bulkEdit')"
        >
          <div>{{ t('edit-members') }}</div>
        </button>
      </div>

      @if (!isDashboardLevel) {
        <button
          mat-menu-item
          [disabled]="!widgetGroup.editable || widgetGroup.isImpact"
          (click)="triggerItemAction('clone')"
        >
          <div>{{ t('clone-group') }}</div>
        </button>
      }
      @if (!isDashboardLevel) {
        <button
          mat-menu-item
          [matMenuTriggerFor]="pagesSubMenu"
          [disabled]="!widgetGroup.editable || dashboardPages.length === 1 || widgetGroup.isImpact"
        >
          <div>{{ t('clone-to-another') }}</div>
        </button>
      }
      @if (widgetGroup.deletable) {
        <button mat-menu-item (click)="triggerItemAction('delete')">
          <div>{{ t('delete-group') }}</div>
        </button>
      }
    </ng-template>
  </mat-menu>

  <mat-menu #pagesSubMenu class="widget-group__pages-submenu">
    <ng-template matMenuContent>
      @for (page of dashboardPages; track page) {
        <button
          mat-menu-item
          [disabled]="page.id === currentDashboardPageId"
          (click)="triggerItemAction('clone', { pageId: page.id })"
        >
          {{ page.title }}
        </button>
      }
    </ng-template>
  </mat-menu>
</ng-container>
